import React from "react";
import styles from "assets/jss/xrs/components/fabStyle.js";
import { makeStyles } from "tss-react/mui";
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

const useStyles = makeStyles()(() => styles);
export default function Fab(props) {
  const [openFab, setopenFab] = React.useState(false);
  const navigate = useNavigate();

  const { classes } = useStyles();

  if (props.open == true) {
    return (
      <div className={classes.fabContainer}>
        <div
          onClick={() => setopenFab(!openFab)}
          className={classes.fab + " " + classes.fabIconHolder}
        >
          <i>
            <AddOutlinedIcon></AddOutlinedIcon>
          </i>
        </div>

        <Box
          component="ul"
          className={classes.fabOptions}
          sx={
            openFab
              ? { transform: "scale(1)", opacity: 1 }
              : { transform: "scale(0)", opacity: 0 }
          }
        >
          <li onClick={() => navigate("/documents")}>
            <span className={classes.fabLabel}>Documents</span>
            <div className={classes.fabIconHolder}>
              <i>
                <InsertDriveFileOutlinedIcon></InsertDriveFileOutlinedIcon>
              </i>
            </div>
          </li>
          <li>
            <span className={classes.fabLabel}>Chat</span>
            <div className={classes.fabIconHolder}>
              <i>
                <CommentOutlinedIcon></CommentOutlinedIcon>
              </i>
            </div>
          </li>
        </Box>
      </div>
    );
  } else {
    return <div></div>;
  }
}
